import React, { useState } from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const GuestRegisterForm = ({ onSuccess }) => {
  const { isDarkMode } = useTheme();
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    mobile: '',
    email: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // اعتبارسنجی
    if (!formData.first_name || !formData.last_name || !formData.mobile) {
      setError('لطفاً تمام فیلدهای الزامی را پر کنید');
      setLoading(false);
      return;
    }

    if (formData.mobile.length < 10) {
      setError('شماره موبایل باید حداقل 10 رقم باشد');
      setLoading(false);
      return;
    }

    try {
      const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
      const response = await fetch(`${BACKEND_URL}/api/novayar/guest-register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.detail || 'خطا در ثبت‌نام');
      }

      if (data.success) {
        onSuccess(data.guest_id);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
      {error && (
        <div className={`px-4 py-3 rounded-xl border transition-colors duration-300 ${
          isDarkMode 
            ? 'bg-red-900/40 border-red-700 text-red-300' 
            : 'bg-red-100 border-red-400 text-red-700'
        }`}>
          <span className="block text-sm sm:text-base">{error}</span>
        </div>
      )}

      <div className="grid sm:grid-cols-2 gap-4">
        <div>
          <label className={`block text-xs sm:text-sm font-medium mb-2 transition-colors duration-300 ${
            isDarkMode ? 'text-gray-300' : 'text-gray-700'
          }`}>
            نام <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="first_name"
            value={formData.first_name}
            onChange={handleChange}
            className={`w-full px-3 sm:px-4 py-2 sm:py-3 rounded-xl border text-sm sm:text-base transition-all duration-300 ${
              isDarkMode 
                ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400 focus:border-blue-500' 
                : 'bg-white border-gray-300 text-gray-800 placeholder-gray-500 focus:border-blue-500'
            } focus:ring-2 focus:ring-blue-500/50 focus:outline-none disabled:opacity-50`}
            placeholder="نام خود را وارد کنید"
            disabled={loading}
          />
        </div>

        <div>
          <label className={`block text-xs sm:text-sm font-medium mb-2 transition-colors duration-300 ${
            isDarkMode ? 'text-gray-300' : 'text-gray-700'
          }`}>
            نام خانوادگی <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="last_name"
            value={formData.last_name}
            onChange={handleChange}
            className={`w-full px-3 sm:px-4 py-2 sm:py-3 rounded-xl border text-sm sm:text-base transition-all duration-300 ${
              isDarkMode 
                ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400 focus:border-blue-500' 
                : 'bg-white border-gray-300 text-gray-800 placeholder-gray-500 focus:border-blue-500'
            } focus:ring-2 focus:ring-blue-500/50 focus:outline-none disabled:opacity-50`}
            placeholder="نام خانوادگی خود را وارد کنید"
            disabled={loading}
          />
        </div>
      </div>

      <div>
        <label className={`block text-xs sm:text-sm font-medium mb-2 transition-colors duration-300 ${
          isDarkMode ? 'text-gray-300' : 'text-gray-700'
        }`}>
          شماره موبایل <span className="text-red-500">*</span>
        </label>
        <input
          type="tel"
          name="mobile"
          value={formData.mobile}
          onChange={handleChange}
          className={`w-full px-3 sm:px-4 py-2 sm:py-3 rounded-xl border text-sm sm:text-base transition-all duration-300 ${
            isDarkMode 
              ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400 focus:border-blue-500' 
              : 'bg-white border-gray-300 text-gray-800 placeholder-gray-500 focus:border-blue-500'
          } focus:ring-2 focus:ring-blue-500/50 focus:outline-none disabled:opacity-50`}
          placeholder="09123456789"
          disabled={loading}
        />
      </div>

      <div>
        <label className={`block text-xs sm:text-sm font-medium mb-2 transition-colors duration-300 ${
          isDarkMode ? 'text-gray-300' : 'text-gray-700'
        }`}>
          ایمیل (اختیاری)
        </label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          className={`w-full px-3 sm:px-4 py-2 sm:py-3 rounded-xl border text-sm sm:text-base transition-all duration-300 ${
            isDarkMode 
              ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400 focus:border-blue-500' 
              : 'bg-white border-gray-300 text-gray-800 placeholder-gray-500 focus:border-blue-500'
          } focus:ring-2 focus:ring-blue-500/50 focus:outline-none disabled:opacity-50`}
          placeholder="email@example.com"
          disabled={loading}
        />
      </div>

      <button
        type="submit"
        disabled={loading}
        className="w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-bold py-3 sm:py-4 px-6 rounded-xl transition-all duration-300 transform hover:scale-105 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none shadow-lg hover:shadow-xl text-sm sm:text-base"
      >
        {loading ? (
          <span className="flex items-center justify-center gap-2">
            <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span>در حال ثبت‌نام...</span>
          </span>
        ) : (
          '🚀 شروع گفتگو با نوآیار'
        )}
      </button>
    </form>
  );
};

export default GuestRegisterForm;